// extracted by mini-css-extract-plugin
export default {"bar":"StatsBar_bar__nkjr6","grid":"StatsBar_grid__hz65C","item":"StatsBar_item__IOShp","num":"StatsBar_num__5+kj3","suffix":"StatsBar_suffix__hmZIx","label":"StatsBar_label__iEEgL"};